<script>
export default {
    data() {
        return {
            model: {
                type: null,
                license: null,
                color: null,
                year: null,
                attachments: [],
            },
        }
    },

    mounted() {
        this.$store.dispatch('title', this.$t('CARS.NEW'))
    },
    methods: {
        save() {
            this.$store.dispatch('carsCreate', this.model).then(() => {
                this.$router.go(-1)
            })
        },

        addFile(f) {
            this.model.attachments.push(f)
        },

        delAttachment(idx) {
            this.model.attachments.splice(idx, 1)
        },
    },
}
</script>

<template lang="pug">
acrm-panel
    form(@submit.prevent="save")
        acrm-heading(:level="4") {{ $t('CARS.BASEDATA')}}
        .row
            .col-24.col-md.col-lg-5
                acrm-input-line(v-model="model.type") {{ $t('CARS.TYPE') }}
            .col-24.col-md.col-lg-5
                acrm-input-line(v-model="model.license") {{ $t('CARS.LICENSE') }}
            .col-24.col-md.col-lg-5
                acrm-input-line(v-model="model.color") {{ $t('CARS.COLOR') }}
            .col-24.col-md.col-lg-5
                acrm-input-line(v-model="model.year" required) {{ $t('CARS.YEAR') }}

        acrm-heading.mt-5(:level="5") {{ $t('CARS.ATTACHMENT') }}
        p {{ $t('CARS.ATTACHMENT_HELP') }}
        acrm-upload(@input="addFile")

        template(v-if="model && model.attachments && model.attachments[0]")
            label.mt-3 {{ $t('BASE.ADDED_ATTACHMENTS') }}
            table.table.table-striped.table-hover()
                thead
                    tr
                        th {{ $t('BASE.FILENAME') }}
                        th {{ $t('BASE.UPLOAD_DATE') }}
                        th &nbsp;
                tbody
                    tr(v-for="(file, index) in model.attachments" :key="file.id")
                        td {{ file.filename }}
                        td {{ file.created_at | toDate }}
                        td.text-right
                            a(:href="file.urls.download")
                                acrm-input-button.d-inline-flex.btn-lg.p-0(variant="link" icon="file_download")
                            acrm-input-button.d-inline-flex.btn-lg.p-0(variant="link" icon="close" @click="delAttachment(index)")

        hr
        .row
            .col-12.col-md-auto.ml-auto
                acrm-input-button.block-md-down(variant="light" @click.prevent="$router.go(-1)") {{ $t('BASE.BACK')}}
            .col-12.col-md-auto
                acrm-input-button.block-md-down(type="submit" variant="success") {{ $t('BASE.CREATE')}}
</template>
